import Vuelidate from 'vuelidate';

export default async({ Vue, store }) => {
   Vue.use(Vuelidate);
   if (parseInt(process.env.WEBSOCKETS_ENABLED, 10) === 1) {
      console.log('broadcast enabled');
      store.commit('ui/setBroadcastEnabled', true);
   }
};
